import {cn} from '@ds/helpers';

type PromotionStockBadgeProps = {
  stock?: number;
  state?: string;
};

const STOCK_STYLES: Record<string, string> = {
  Available: 'bg-success-surface text-success',
  Critical: 'bg-yellow-soft text-warning',
  OutOfStock: 'bg-destructive-surface text-destructive'
};

const STOCK_LABELS: Record<string, string> = {
  Available: 'موجود',
  Critical: 'رو به اتمام',
  OutOfStock: 'ناموجود'
};

const PromotionStockBadge: React.FC<PromotionStockBadgeProps> = ({stock, state}) => {
  if (!state || !STOCK_LABELS[state]) {
    return null;
  }

  return (
    <div
      className={cn(
        'inline-flex h-5.5 min-w-15 items-center justify-center rounded px-1.5 text-body-xs',
        STOCK_STYLES[state]
      )}
    >
      <span>{STOCK_LABELS[state]}</span>
      {state !== 'OutOfStock' ? <span className="ms-1">({stock})</span> : null}
    </div>
  );
};

export default PromotionStockBadge;
